import { GETWORKSPACELIST_SUCCESS, GETWORKSPACELIST_FAIL } from '../actionTypes';

const initialState = {
    user: []
};

const getWorkspaceListReducer = (state = initialState, action) => {
    switch (action.type) {
        case GETWORKSPACELIST_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case GETWORKSPACELIST_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default getWorkspaceListReducer;
